import { useContext } from 'react';
import { AppContext } from '../../../context/AppContext';
import styles from './SearchBarCriteriaInput.module.scss';

const SearchBarCriteriaInput = () => {
  const { name, updateName } = useContext(AppContext);

  return (
    <>
      <div className={styles.criteriaInputContainer}>
        <input
          className={styles.criteriaInput}
          type="text"
          placeholder="Doctor name, practice, facility, or pharmacy"
          value={name === 'undefined' ? '' : name}
          onChange={(e) => updateName(e.target.value)}
        />
      </div>
    </>
  );
};

export default SearchBarCriteriaInput;
